import React, { Component } from 'react';
import { Glyphicon, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions } from '../../actions';
import { uploadState as UploadState } from '../../constants';
import '../../content/css/UploadDocument.css';
import UploadDocument from './UploadDocument';
import { history } from "../../helpers";
import AuthService from '../../services/auth.service';
import AlertDismissable from './AlertDismissable';
import LimitedOfferModal from '../Misc/LimitedOfferModal';
import ContractTypePicker from '../Misc/ContractTypePicker';

var logo = require("../../content/images/legly_logo_color.svg");
var warning = require("../../content/images/warning-icon.png");

class UploadView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            files: [],
            failedFiles: []
        };

        this.authService = new AuthService();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.uploadState === UploadState.PROCESSING && prevProps.uploadState === UploadState.UPLOADING_SINGLE) {
            console.log("Will ask to process document now. ID: " + this.props.uploadId);
            this.props.processDocument(this.props.uploadId);
        }
        if (this.props.uploadState === UploadState.LOADING && prevProps.uploadState === UploadState.SELECTING_TYPE) {
            this.props.requestDocumentAnalysis(this.props.uploadId);
        }
        if (this.props.uploadState === UploadState.LOADING && this.props.analyzedDocuments[this.props.id] && !prevProps.analyzedDocuments[this.props.id]) {
            this.props.resetUploadState();
            history.push(`/${this.props.id}`);
        }

        if (this.props.uploadState === UploadState.END_OF_MULTIUPLOAD) {
            // this.props.resetUploadState();
            // history.push(`/documents`);
        }

        if (this.props.uploadError != prevProps.uploadError) {
            console.log("this.props.uploadError: " + this.props.uploadError);
            if (this.props.uploadError != undefined) {
                this.state.failedFiles.push(this.props.uploadError)
            }
        }

        if (this.props.exceptions != prevProps.exceptions && this.props.exceptions.length > 0) {
            throw this.props.exceptions[0];
        }
    }

    getCurrentDocument() {
        let doc = this.props.analyzedDocuments[this.props.id];
        return doc;
    }

    getStatusText() {
        switch (this.props.uploadState) {
            case UploadState.UPLOADING_SINGLE:
                return "Uploading the document...";
            case UploadState.PROCESSING:
                return "Processing the document...";
            case UploadState.SELECTING_TYPE:
                return "Processing the document...";
            case UploadState.LOADING:
                return "Analyzing the document...";
            default:
                return "";
        }
    }

    handleUpload = (files) => {
        this.setState({ files: files });
        this.props.upload(files);
    }

    handleMultiUploadFinished() {
        this.props.resetUploadState();
        history.push(`/documents`);
    }

    handleSelectType = (theme, hasChildren) => {
        if (hasChildren) return;
        this.props.editDocumentType(this.props.uploadId, theme.contractType, true);
    }

    getWarningAlert() {
        let email = this.authService.getEmail();
        if (email && email.includes("@electrolux")) {
            return <AlertDismissable />;
        }
    }

    getTimeToNewFreeReview() {
        let timeToNewFreeReview = this.authService.timeToNewFreeReview();
        if (timeToNewFreeReview > 30 * 24 * 60 * 60 * 1000) return Math.round(timeToNewFreeReview / (30 * 24 * 60 * 60 * 1000)) + " months";
        else if (timeToNewFreeReview > 24 * 60 * 60 * 1000) return Math.round(timeToNewFreeReview / (24 * 60 * 60 * 1000)) + " days";
        else if (timeToNewFreeReview > 60 * 60 * 1000) return Math.round(timeToNewFreeReview / (60 * 60 * 1000)) + " hours";
        else if (timeToNewFreeReview > 60 * 1000) return Math.round(timeToNewFreeReview / (60 * 1000)) + " minutes";
        else if (timeToNewFreeReview > 2000) return Math.round(timeToNewFreeReview / 1000) + " seconds";
        else if (timeToNewFreeReview > 0) return "1 second";
        else if (timeToNewFreeReview <= 0) return 0 + " seconds";
    }

    render() {
        let isGuest = this.authService.isGuest();
        let isGuestAndOutOfReviews = isGuest && this.authService.getFreeReviewsLeft() <= 0;
        let isAllowedToUpload = this.authService.isAdmin() || this.authService.isCustomer() || (isGuest && !isGuestAndOutOfReviews);
        return (
            <div className="prototype-start">
                <Image className="logo" src={logo} />
                {this.getWarningAlert()}
                {(isAllowedToUpload || this.props.uploadState !== UploadState.START) &&
                    <React.Fragment>
                        <h3>Upload your contract for review</h3>
                        <div className="upload-step-container">
                            {isAllowedToUpload && this.props.uploadState === UploadState.START &&
                                <UploadDocument file={this.props.uploadFile} onUpload={this.handleUpload} />
                            }

                            {(this.props.uploadState === UploadState.UPLOADING_MULTIPLE || this.props.uploadState === UploadState.END_OF_MULTIUPLOAD) &&
                                <React.Fragment>
                                    <span
                                        className="upload-left-to-upload">{this.state.files.length - this.props.finishedFiles.length} left to upload</span>
                                    <br />
                                    <span>Number of selected files: {this.state.files.length}</span>


                                    <ul className="upload-multiple-errors-list">
                                        {this.state.failedFiles &&
                                            this.state.failedFiles.map((failedFile, index) => (
                                                <li>{failedFile}</li>
                                            ))}
                                    </ul>
                                </React.Fragment>
                            }

                            {this.props.uploadState === UploadState.END_OF_MULTIUPLOAD &&
                                <React.Fragment>
                                    <button type="button" className="btn btn-labeled btn-default btn-back select-type" onClick={() => this.props.resetUploadState()} >
                                        <span className="btn-label"><Glyphicon glyph="repeat" /></span>Upload again
                                    </button><br />
                                    <button type="button" className="btn btn-labeled btn-default btn-back select-type" onClick={() => this.handleMultiUploadFinished()} >
                                        <span className="btn-label"><Glyphicon glyph="chevron-right" /></span>Go to documents
                                    </button>

                                </React.Fragment>
                            }

                            {this.props.uploadState === UploadState.WAITING_TO_SELECT_TYPE &&
                                <ContractTypePicker onSelect={this.handleSelectType} />
                            }

                            {this.props.uploadState !== UploadState.START
                                && this.props.uploadState !== UploadState.WAITING_TO_SELECT_TYPE
                                && this.props.uploadState !== UploadState.UPLOADING_MULTIPLE
                                && this.props.uploadState !== UploadState.END_OF_MULTIUPLOAD &&
                                <React.Fragment>
                                    <span>{this.getStatusText()}</span>
                                    <br />
                                    <span>Please wait. This can take up to a minute.</span>
                                </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
                }
                {!isAllowedToUpload && isGuestAndOutOfReviews && this.props.uploadState === UploadState.START &&
                    <React.Fragment>
                        <div className="warning-container">
                            <Image className="warning" src={warning} />
                            <div>
                                <h3>You are out free reviews!</h3>
                                <h4>Come back in {this.getTimeToNewFreeReview()} to upload again.</h4>
                            </div>
                        </div>
                        <LimitedOfferModal />
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(UploadView);


// WEBPACK FOOTER //
// ./src/components/Upload/UploadView.js